import React from 'react';
import Link from '../Link';
import Avatar from '../Avatar';
import FollowButton from '../FollowButton';

if (process.browser) require('./Author.scss');

const Name = ({ url, name, track }) => (
  url
    ? <Link external to={url} title="author-name" track={track}>{name}</Link>
    : <span className="name" data-name="author-name">{name}</span>
);
const Position = ({ position }) => (position ? <span data-name="author-position">{position}</span> : null);
const Institution = ({ institution }) => (institution ? <span data-name="author-institution">{institution}</span> : null);

const getAvatar = (photos = []) => {
  const { url } = photos.find(photo => photo.width === 64) || {};
  return url || null;
};

export default function Author({
  id,
  firstName,
  lastName,
  institution,
  link,
  track,
  employment = {},
  photos = [],
}) {
  const name = firstName ? `${firstName} ${lastName}` : `${lastName}`;
  const tracking = {
    ...track,
    action: 'ViewAuthor',
    value: {
      ...track.value,
      name
    }
  };

  return (
    <div className="author" data-name="author">
      <Avatar avatar={getAvatar(photos)} linkTo={link} linkTitle="Author Profile" className="avatar" track={tracking} />
      <p className="details">
        <Name url={link} name={name} track={tracking} />
        <Position {...employment} />
        <Institution institution={institution} />
      </p>
      <FollowButton userId={id} track={track} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/AuthorsList/Author.js